import React from 'react'
import MaterialSymbol from '../material-symbol'

const KeyboardArrowLeft = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="keyboard_arrow_left" {...props} />
))

KeyboardArrowLeft.displayName = 'KeyboardArrowLeft'

export default KeyboardArrowLeft
